import { useEffect, useState } from 'react';
import {
  TextField
} from '@mui/material';


export const OrderNumberField = (props) => {
  const { onChange, original_value } = props
  const [ value, setValue ] = useState(original_value)

  useEffect(() => {
    setValue(original_value)
  }, [original_value])


  return (
    <TextField
      sx={{width: '100%'}}
      variant='standard'
      label="Order Number"
      value={value}
      onChange={(e) => { 
        if (onChange) { onChange(e.target.value) }
        setValue(e.target.value) 
      }}
    />
  )
}